var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon32Tasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V4C1.5 4.27614 1.72386 4.5 2 4.5H3C3.27614 4.5 3.5 4.27614 3.5 4V3C3.5 2.72386 3.27614 2.5 3 2.5H2ZM3 3H2V4H3V3Z",
    fill: "#5CB2EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H14.5C14.7761 3 15 3.22386 15 3.5C15 3.77614 14.7761 4 14.5 4H5.5C5.22386 4 5 3.77614 5 3.5Z",
    fill: "#5CB2EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H5.5Z",
    fill: "#5CB2EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12H14.5C14.7761 12 15 11.7761 15 11.5C15 11.2239 14.7761 11 14.5 11H5.5Z",
    fill: "#5CB2EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7C1.5 6.72386 1.72386 6.5 2 6.5H3C3.27614 6.5 3.5 6.72386 3.5 7V8C3.5 8.27614 3.27614 8.5 3 8.5H2C1.72386 8.5 1.5 8.27614 1.5 8V7ZM2 7H3V8H2V7Z",
    fill: "#5CB2EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5C1.72386 10.5 1.5 10.7239 1.5 11V12C1.5 12.2761 1.72386 12.5 2 12.5H3C3.27614 12.5 3.5 12.2761 3.5 12V11C3.5 10.7239 3.27614 10.5 3 10.5H2ZM3 11H2V12H3V11Z",
    fill: "#5CB2EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Tasks);
export default __webpack_public_path__ + "static/media/icon32-tasks.7d016f38d1f079d466073b40dd5f937e.svg";
export { ForwardRef as ReactComponent };